<template>
	<div>
        <!-- alpha fix- added || action_loader to the condition  -->
		<div class="custom-loader-wrapper for-employee-page" v-if="payslip_loader|| action_loader">
			<div class="text-center">
				<span class="d-block max-450">{{payslip_loader_text}}</span>
				<img v-bind:src="$api_url+'/images/download-loader.svg'" class="loader-logo" width="100px"/>
			</div>
		</div>
		<form @submit="formSubmit" enctype="multipart/form-data">
		<input class="input" type="hidden" v-model="fdata.id" >
		<input class="input" type="hidden" v-model="employee_id" >
		<input class="input" type="hidden" v-model="fiscal_year" >
		<input class="input" type="hidden" v-model="from_date" >
		<input class="input" type="hidden" v-model="to_date" >
		<input class="input" type="hidden" v-model="pay_slip_ref" >
		<input class="input" type="hidden" v-model="pay_slip_name" >

		<div class="row ">
			<div class="col-md-12 action-button">
				<b-overlay :show="action_loader" rounded="sm">
                    <!-- alpha fix- swap the brtn  -->
                    <b-button class="border rounded bg-light float-right py-1 px-2 ml-2 custom-wizard-btn custom-wizard2-btn" type="submit" variant="primary" @click="emailTaxCards(payslip)" v-if="$acl['modifypayslips'] == 2"><i class="far fa-envelope px-1" aria-hidden="true" style="font-size:16px;"></i> Email</b-button>
					<b-button class="border rounded bg-light float-right py-1 px-2 ml-2" type="submit" variant="primary" @click="downloadPaySlip(payslip,fiscal_year)" v-if="$acl['downloadpayslips'] == 2">Download PDF</b-button>

				</b-overlay>
			</div>
		</div>

		<div class="row payslip-details-card">
		  <div class="col-md-12 text-center pay-slip-title">
			<p class="first">{{company_name}}</p>
			<p class="second"> <span>{{payslip_title}}</span></p>
			<p class="third">Income Year {{fiscal_year}}</p>
		  </div>
		</div>

		<div class="row payslip-details-card">
		  <div class="col-md-12 payslip-details-info">
			<div class="row payslip-details-info-inner">
			  <template v-for="(row, index) in dynamic_fields">

				<div class="col-md-6 payslip-details-info-right">
					<div class="wrapper">
					<div class='first' :key="index" ><strong v-if="index == 0">{{row.header_left_name}}</strong><template v-else>{{row.header_left_name}}</template></div>
					<div class='second'>
						<template v-if="row.header_left_name !='Month'"><strong v-if="index == 0">{{row.header_left_value}}</strong><template v-else>{{row.header_left_value}}</template></template>
						<template v-else><strong v-if="index == 0">{{pmonth+' '+pyear}}</strong><template v-else>{{pmonth+' '+pyear}}</template></template>
					</div>
					</div>
				</div>

				<div class="col-md-6 payslip-details-info-right">
					<div class="wrapper">
					<div class='first'><strong v-if="index == 0">{{row.header_right_name}}</strong><template v-else>{{row.header_right_name}}</template></div>
					<div class='second'>
						<template v-if="row.header_right_name != 'Month'"><strong v-if="index == 0">{{row.header_right_value}}</strong><template v-else>{{row.header_right_value}}</template></template>
						<template v-else><strong v-if="index == 0">{{pmonth+' '+pyear}}</strong><template v-else>{{pmonth+' '+pyear}}</template></template>
					</div>
					</div>
				</div>

			  </template>
			</div>
		  </div>
		</div>

		<div class="row payslip-details-card">

		  	<div class="col-md-12">
			<div class="payslip-details-title">Income Details</div>

				<table class="table table-bordered">
					<thead>
						<tr class="table-head" style="font-weight: bold; text-align: center;"><td>Gross Salary</td><td class="text-center">Amount(Taka)</td></tr>
                        <tr class="hover-bg table-row border-bottom head-second"><td  class="pay-allowances" colspan="2">Pay &amp; Allowances:</td></tr>
					</thead>
					<tbody class="slip-details-table">
						<tr class="hover-bg table-row border-bottom" v-for="salaryhead in salaryheads" :key="salaryhead.head" v-if="salaryhead.displayset == '1'">
						<template v-if="pre_gross_flag == 1">
							<template v-if="salaryhead.field_key != 'basic_salary' && salaryhead.field_key != 'house_rent' && salaryhead.field_key != 'conveyance_allowance' && salaryhead.field_key != 'medical_allowance'">
								<td>{{salaryhead.head}} </td><td  style="text-align: right;">{{salaryhead.value}}</td>
							</template>
						</template>
						<template v-else>
							<td>{{salaryhead.head}} </td><td  style="text-align: right;">{{salaryhead.value}}</td>
						</template>
						</tr>

						<tr class="hover-bg table-row border-bottom" v-for="salaryhead in salaryheads" :key="salaryhead.head" v-if="(salaryhead.displayset == 'custom_gross_salary_components') && salaryhead.value!='0' && salaryhead.value!='(0)' && salaryhead.value!='0.00' && salaryhead.value!='(0.00)'">
						<td>{{salaryhead.head}} </td><td  style="text-align: right;">{{salaryhead.value}}</td>
						</tr>

						<tr class="hover-bg table-row border-bottom" v-for="salaryhead in salaryheads" :key="salaryhead.head" v-if="(salaryhead.displayset == 'pre_adhoc_deduction' || salaryhead.displayset == 'pre_deduction_incremental_hours' || salaryhead.displayset == 'pre_deduction_incremental_days' || salaryhead.displayset == 'pre_deduction_fixed' || salaryhead.displayset == 'pre_deduction_manual') && salaryhead.value!='0' && salaryhead.value!='(0)' && salaryhead.value!='0.00' && salaryhead.value!='(0.00)'">
						<td>{{salaryhead.head}} </td><td  style="text-align: right;">({{salaryhead.value}})</td>
						</tr>

						<template v-if="pre_gross_flag == 1">
						<tr class="s-tfoot" v-for="salaryhead in salaryheads" :key="salaryhead.head" v-if="salaryhead.head == 'Salary Without Additions'"><td class="font-weight-bold">Total Gross Salary</td><td style="text-align: right;">{{salaryhead.value}}</td></tr>
						</template>
						<template v-else>
						<tr class="s-tfoot" v-for="salaryhead in salaryheads" :key="salaryhead.head" v-if="salaryhead.head == 'Salary Without Additions'"><td class="font-weight-bold">Total Gross Salary</td><td style="text-align: right;">{{moneyFormat(gross_salary)}}</td></tr>
						</template>

					</tbody>
				</table>
				<table class="table table-bordered">
					<thead>
						<tr class="table-head" style="font-weight: bold; text-align: center;"><td>Other Benefits &amp; Allowances </td><td class="text-center">Amount(Taka)</td></tr>
					</thead>
					<tbody class="slip-details-table">

						<tr class="hover-bg table-row border-bottom" v-for="salaryhead in salaryheads" :key="salaryhead.head" v-if="salaryhead.displayset == '1.1' && salaryhead.value!='0' && salaryhead.value!='(0)' && salaryhead.value!='0.00' && salaryhead.value!='(0.00)'">
						<td>{{salaryhead.head}} (Taxable) </td><td  style="text-align: right;">{{salaryhead.value}}</td>
						</tr>


						<tr class="hover-bg table-row border-bottom" v-for="salaryhead in salaryheads" :key="salaryhead.head" v-if="salaryhead.displayset == '2' && salaryhead.value!='0' && salaryhead.value!='(0)' && salaryhead.value!='0.00' && salaryhead.value!='(0.00)'">
						<td>{{salaryhead.head}} (Non Taxable) </td><td  style="text-align: right;">{{salaryhead.value}}</td>
						</tr>

						<tr class="hover-bg table-row border-bottom" v-for="salaryhead in salaryheads" :key="salaryhead.head" v-if="salaryhead.displayset == 'adhoc' && salaryhead.value!='0' && salaryhead.value!='(0)' && salaryhead.value!='0.00' && salaryhead.value!='(0.00)'">
						<td>{{salaryhead.head}} (Taxable) </td><td  style="text-align: right;">{{salaryhead.value}}</td>
						</tr>

						<tr class="hover-bg table-row border-bottom" v-for="salaryhead in salaryheads" :key="salaryhead.head" v-if="(salaryhead.displayset=='overtime_holiday_manual' || salaryhead.displayset=='overtime_holiday_incremental_days' || salaryhead.displayset=='overtime_holiday_fixed' || salaryhead.displayset=='overtime_holiday_incremental_hours') && salaryhead.value!='0' && salaryhead.value!='(0)' && salaryhead.value!='0.00' && salaryhead.value!='(0.00)'">
						<td>{{salaryhead.head}} (Taxable) </td><td  style="text-align: right;">{{salaryhead.value}}</td>
						</tr>

						<tr class="hover-bg table-row border-bottom" v-for="salaryhead in salaryheads" :key="salaryhead.head" v-if="(salaryhead.displayset=='overtime_holiday_manual_non_taxable' || salaryhead.displayset=='overtime_holiday_fixed_non_taxable' || salaryhead.displayset=='overtime_holiday_incremental_days_non_taxable' || salaryhead.displayset=='overtime_holiday_incremental_hours_non_taxable') && salaryhead.value!='0' && salaryhead.value!='(0)' && salaryhead.value!='0.00' && salaryhead.value!='(0.00)'">
						<td>{{salaryhead.head}} (Taxable) </td><td  style="text-align: right;">{{salaryhead.value}}</td>
						</tr>

						<tr class="hover-bg table-row border-bottom" v-for="salaryhead in salaryheads" :key="salaryhead.head" v-if="salaryhead.displayset == 'adhoc_nontax'  && salaryhead.value!='0' && salaryhead.value!='(0)' && salaryhead.value!='0.00' && salaryhead.value!='(0.00)'">
						<td>{{salaryhead.head}} (Non Taxable) </td><td  style="text-align: right;">{{salaryhead.value}}</td>
						</tr>

						<tr class="hover-bg table-row border-bottom" v-for="salaryhead in salaryheads" :key="salaryhead.head" v-if="(salaryhead.displayset=='contracted_variable_payslip') && salaryhead.value!='0' && salaryhead.value!='(0)' && salaryhead.value!='0.00' && salaryhead.value!='(0.00)'">
						<td>{{salaryhead.head}} (Taxable) </td><td  style="text-align: right;">{{salaryhead.value}}</td>
						</tr>

						<tr class="hover-bg table-row border-bottom" v-for="salaryhead in salaryheads" :key="salaryhead.head" v-if="salaryhead.head == 'Arrear Basic Salary'  && salaryhead.value!='0' && salaryhead.value!='(0)' && salaryhead.value!='0.00' && salaryhead.value!='(0.00)'">
						<td>{{salaryhead.head}} </td><td  style="text-align: right;">{{salaryhead.value}}</td>
						</tr>

						<tr class="hover-bg table-row border-bottom" v-for="salaryhead in salaryheads" :key="salaryhead.head" v-if="salaryhead.head == 'Arrear Medical Allowance'  && salaryhead.value!='0' && salaryhead.value!='(0)' && salaryhead.value!='0.00' && salaryhead.value!='(0.00)'">
						<td>{{salaryhead.head}} </td><td  style="text-align: right;">{{salaryhead.value}}</td>
						</tr>

						<tr class="hover-bg table-row border-bottom" v-for="salaryhead in salaryheads" :key="salaryhead.head" v-if="salaryhead.head == 'Arrear Conveyance Allowance'  && salaryhead.value!='0' && salaryhead.value!='(0)' && salaryhead.value!='0.00' && salaryhead.value!='(0.00)'">
						<td>{{salaryhead.head}} </td><td  style="text-align: right;">{{salaryhead.value}}</td>
						</tr>

						<tr class="hover-bg table-row border-bottom" v-for="salaryhead in salaryheads" :key="salaryhead.head" v-if="salaryhead.head == 'Arrear House Rent Allowance'  && salaryhead.value!='0' && salaryhead.value!='(0)' && salaryhead.value!='0.00' && salaryhead.value!='(0.00)'">
						<td>{{salaryhead.head}} </td><td  style="text-align: right;">{{salaryhead.value}}</td>
						</tr>

						<tr class="hover-bg table-row border-bottom" v-for="salaryhead in salaryheads" :key="salaryhead.head" v-if="salaryhead.displayset == 'custom_gross_salary_components_arrear'  && salaryhead.value!='0' && salaryhead.value!='(0)' && salaryhead.value!='0.00' && salaryhead.value!='(0.00)'">
						<td>{{salaryhead.head}} </td><td  style="text-align: right;">{{salaryhead.value}}</td>
						</tr>

						<tr class="hover-bg table-row border-bottom" v-for="salaryhead in salaryheads" :key="salaryhead.head" v-if="salaryhead.head == 'Arrear PF Contribution'  && salaryhead.value!='0' && salaryhead.value!='(0)' && salaryhead.value!='0.00' && salaryhead.value!='(0.00)'">
						<td>{{salaryhead.head}} </td><td  style="text-align: right;">{{salaryhead.value}}</td>
						</tr>

						<tr class="hover-bg table-row border-bottom" v-for="salaryhead in salaryheads" :key="salaryhead.head" v-if="salaryhead.displayset == 'off_cycle_adhocs'  && salaryhead.value!='0' && salaryhead.value!='(0)' && salaryhead.value!='0.00' && salaryhead.value!='(0.00)'">
						<td>{{salaryhead.head}} </td><td  style="text-align: right;">{{salaryhead.value}}</td>
						</tr>

						<tr class="hover-bg table-row border-bottom" v-for="salaryhead in salaryheads" :key="salaryhead.head" v-if="salaryhead.head == 'Display Loan in Payslip' && salaryhead.displayset == 'display_loan_in_payslip'">
						<td>Loan/Advance Distributed</td><td  style="text-align: right;">{{salaryhead.value}}</td>
						</tr>

						<tr class="hover-bg table-row border-bottom" v-for="salaryhead in salaryheads" :key="salaryhead.head" v-if="salaryhead.head == 'Display PF Loan in Payslip' && salaryhead.displayset == 'display_pf_loan_in_payslip'">
						<td>PF Loan Distributed</td><td  style="text-align: right;">{{salaryhead.value}}</td>
						</tr>

					<tr class="s-tfoot" v-for="salaryhead in salaryheads" :key="salaryhead.head" v-if="salaryhead.head == 'Total Additions'  && salaryhead.value!='0' && salaryhead.value!='(0)' && salaryhead.value!='0.00' && salaryhead.value!='(0.00)'">
						<td>Total Other Benefits &amp; Allowances</td>
						<td style="text-align: right;">{{salaryhead.value}}</td>
						</tr>

						<tr v-for="salaryhead in salaryheads" :key="salaryhead.head" v-if="salaryhead.head == 'Gross Pay'  && salaryhead.value!='0' && salaryhead.value!='(0)' && salaryhead.value!='0.00' && salaryhead.value!='(0.00)'" class="table-head">
						<td class="font-weight-bold text-left" style="text-align: left !important;"> Total Earnings  </td><td  style="text-align: right !important;">{{salaryhead.value}}</td>
						</tr>
					</tbody>
				</table>

				<table class="table table-bordered">
					<thead>
						<tr class="table-head" style="font-weight: bold; text-align: center;"><td>Deductions</td><td class="text-center">Amount(Taka)</td></tr>
					</thead>
					<tbody class="slip-details-table">

						<tr class="hover-bg table-row border-bottom" v-for="salaryhead in salaryheads" :key="salaryhead.head" v-if="salaryhead.head == 'Employer\'s Contribution to PF'">
						<td>Employer's Contribution to PF</td> <td style="text-align: right;">({{salaryhead.value}}) </td>
						</tr>

						<tr class="table-row hover-bg" v-for="salaryhead in salaryheads" :key="salaryhead.head" v-if="(salaryhead.head == 'Arrear Employer\'s Contribution to PF' || salaryhead.head == 'Arrear PF Employer\'s Contribution') && salaryhead.value!='-0' && salaryhead.value!='0' && salaryhead.value!='(0)' && salaryhead.value!='0.00' && salaryhead.value!='(0.00)' && salaryhead.value!='-0.00'">
						<td>Arrear PF Employer's Contribution</td> <td style="text-align: right;">({{salaryhead.value}}) </td> 
						</tr>

						<template v-if="tax_policy_flag">
							<tr class="hover-bg table-row border-bottom" v-for="salaryhead in salaryheads" :key="salaryhead.head" v-if="salaryhead.displayset == '5'  && salaryhead.value!='-0' && salaryhead.head!='AIT Surplus' && salaryhead.value!='0' && salaryhead.value!='(0)' && salaryhead.value!='0.00' && salaryhead.value!='(0.00)' && salaryhead.value!='-0.00' && salaryhead.head!='Income Tax' && salaryhead.head!='Monthly Tax' && salaryhead.head!='One-off Tax Deduct'">
							<td>{{salaryhead.head}}</td> <td style="text-align: right;">({{Math.abs(parseFloat(salaryhead.value.replace(/\,/g,''))).toLocaleString()}})</td>
							</tr>
						</template>

						<template v-else>
							<tr class="hover-bg table-row border-bottom" v-for="salaryhead in salaryheads" :key="salaryhead.head" v-if="salaryhead.displayset == '5'  && salaryhead.value!='-0' && salaryhead.head!='AIT Surplus' && salaryhead.value!='0' && salaryhead.value!='(0)' && salaryhead.value!='0.00' && salaryhead.value!='(0.00)' && salaryhead.value!='-0.00'">
							<td>{{salaryhead.head}}</td> <td style="text-align: right;">({{Math.abs(parseFloat(salaryhead.value.replace(/\,/g,''))).toLocaleString()}})</td>
							</tr>
						</template>

						<tr class="hover-bg table-row border-bottom" v-for="salaryhead in salaryheads" :key="salaryhead.head" v-if="salaryhead.displayset == 'for_payslip_deduction'  && salaryhead.value!='-0' && salaryhead.value!='0' && salaryhead.value!='(0)' && salaryhead.value!='0.00' && salaryhead.value!='(0.00)' && salaryhead.value!='-0.00'">
						<td>{{salaryhead.head}}</td> <td style="text-align: right;">({{Math.abs(parseFloat(salaryhead.value.replace(/\,/g,''))).toLocaleString()}})</td>
						</tr>

						<tr class="hover-bg table-row border-bottom" v-for="salaryhead in salaryheads" :key="salaryhead.head" v-if="(salaryhead.displayset == 'adhoc_deduction' || salaryhead.displayset=='post_deduction_manual' || salaryhead.displayset=='post_deduction_fixed' || salaryhead.displayset=='post_deduction_incremental_days' || salaryhead.displayset=='post_deduction_incremental_hours')  && salaryhead.value!='-0' && salaryhead.value!='0' && salaryhead.value!='(0)' && salaryhead.value!='0.00' && salaryhead.value!='(0.00)' && salaryhead.value!='-0.00'">
						<td>{{salaryhead.head}}</td> <td style="text-align: right;">({{Math.abs(parseFloat(salaryhead.value.replace(/\,/g,''))).toLocaleString()}})</td>
						</tr>

						<tr class="hover-bg table-row border-bottom" v-for="salaryhead in salaryheads" :key="salaryhead.head" v-if="salaryhead.head == 'Arrear PF Contribution'  && salaryhead.value!='0' && salaryhead.value!='(0)' && salaryhead.value!='0.00' && salaryhead.value!='(0.00)' && salaryhead.value!='-0.00'">
						<td>Arreae PF Employer's Contribution</td><td style="text-align: right;">({{Math.abs(parseFloat(salaryhead.value.replace(/\,/g,''))).toLocaleString()}})</td>
						</tr>

						<tr class="hover-bg table-row border-bottom" v-for="salaryhead in salaryheads" :key="salaryhead.head" v-if="salaryhead.head == 'AIT Adjustment' && salaryhead.value!='0' && salaryhead.value!='(0)' && salaryhead.value!='0.00' && salaryhead.value!='(0.00)' && salaryhead.value!='-0.00'">
						<td>AIT Adjustment</td> <td style="text-align: right;">({{Math.abs(parseFloat(salaryhead.value.replace(/\,/g,''))).toLocaleString()}})</td>
						</tr>

						<tr class="s-tfoot" v-for="salaryhead in salaryheads" :key="salaryhead.head" v-if="salaryhead.displayset == '500' ">
						<td class="font-weight-bold">Total Deductions</td> <td style="text-align: right;">({{salaryhead.value}})</td>
						</tr>

					</tbody>
				</table>
				<table class="table table-bordered">
					<tbody class="slip-details-table">

						<tr class="table-head" v-for="salaryhead in salaryheads" :key="salaryhead.head" v-if="salaryhead.displayset == '7'">
						<td class="font-weight-bold" style="text-align: left !important;">Net Salary</td> <td style="text-align: right !important;"><b>{{salaryhead.value}}</b></td>
						</tr>
						<tr class="hover-bg table-row border-bottom">
						<td colspan="2">
						<span v-for="salaryhead in salaryheads" :key="salaryhead.head" v-if="salaryhead.displayset == '7'">
						<template>
						<inwords :amount="salaryhead.value"></inwords>
						</template>
						</span>
						</td>
						</tr>

					</tbody>
				</table>

				<template v-if="tax_policy_flag">
					<table class="table table-bordered">
						<tbody class="slip-details-table">
							<tr class="table-head" v-for="salaryhead in taxinfo" :key="salaryhead.head" v-if="salaryhead.displayset == 'total_tax'">
								<td class="font-weight-bold">Income Tax Paid By Employer</td> <td style="text-align: right;"><b>{{salaryhead.value}}</b></td>
							</tr>
						</tbody>
					</table>
				</template>


				<template v-for="salaryhead in salaryheads">
					<table class="table table-bordered" v-if="salaryhead.rfa > 0  || salaryhead.cpu > 0 || salaryhead.oncp > 0" :key="salaryhead.head">
						<thead>
							<tr class="table-head" style="font-weight: bold; text-align: center;"><td>Non-Cash Taxable Benefits</td><td class="text-center"></td></tr>
						</thead>
						<tbody class="slip-details-table">

							<tr class="hover-bg table-row border-bottom" v-for="salaryhead in salaryheads" :key="salaryhead.head" v-if="salaryhead.displayset == '1.2'  && salaryhead.head=='Rent-free Accomodation' && salaryhead.rawvalue > 0"><td>Rent-free accommodation</td><td style="text-align: right;">
							<span>{{salaryhead.value}}</span>
							</td></tr>
							<tr class="hover-bg table-row border-bottom" v-for="salaryhead in salaryheads" :key="salaryhead.head" v-if="salaryhead.displayset == '1.2'  && salaryhead.head=='Conveyance for Personal/Private Use' && salaryhead.rawvalue > 0"><td>Conveyance for personal use</td><td style="text-align: right;">
							<span>{{salaryhead.value}}</span>
							</td></tr>
							<tr class="hover-bg table-row border-bottom" v-for="salaryhead in salaryheads" :key="salaryhead.head" v-if="salaryhead.displayset == '1.2'  && salaryhead.head=='Other Non-Cash Perquisites' && salaryhead.rawvalue > 0"><td>Other Perquisites, Allowances and Benefits</td><td style="text-align: right;">
							<span>{{salaryhead.value}}</span>
							</td></tr>

						</tbody>
					</table>
				</template>

		   	</div>
	 	</div>


	  <div class="row mt-2">
		  <div class="col-md-12">
		   <p class="mt-5 mb-5 text-center">**Computer generated pay slip does not require signature**</p>
		  </div>
	   </div>
	   </form>
	</div>
</template>
<style scoped>
.s-thead{background: #c9c9c9;}
.s-tfoot{background: #e5e5e5;}
.s-section{background: #5b6992;}
</style>

<script>
  export default {
	  mounted() {
		 // console.log('Payslip started..');
		 // console.log(this.componentdata);
	  },
	  props: [, 'payslip','company','payslipname','emp_etin','emp_department','emp_jobposition','emp_code','emp_joining','emp_branch','pmonth','pyear','dynamic_fields'],
	  data() {

		  return {
			  total_other:0.0, //at_edit
			  contribution: 0.0, //at-edit 9 nov 21
			  deduction: 0.0, //at-edit 9 nov 21
			gross_salary: 0.0, //at-edit 9 nov 21
			  employees : [],
			  salaryheads : [],
			  taxinfo : [],
			  taxdata : [],
			  fiscalyears: [],
			  adhocfields: [],
			  adhocheadsnvalues: [],
			  slabs_and_values : [],
			  fdata: [],
			  company_name:this.company,
			  payslip_title: this.payslipname,
			  download_file_name: '',
			  success: '',
			  employee_id: '',
			  fiscal_year: '',
			  from_date: '',
			  to_date: '',
			  pay_slip_ref: '',
			  pay_slip_name: '',
			  month: '',
			  year: '',
			  adhoc_field: '',
			  adhoc_field_value: '',
			  action_loader: false,
			  decimal_setting: '',
			  pre_gross_flag: 0,
			  payslip_loader_text: 'We are preparing the data for this employee.',
				payslip_loader : false,
				tax_policy_flag : false,
		  }
	  },

	  methods:{
		  setSearch: function(pageflg)
		  {
			this.getSalaryinfo();
		  },
		  moneyFormat(amount)
		  {
			var money = Number(amount);
			money = money.toLocaleString();
			if(money=='NaN')
				money = amount;
			else
				if(this.decimal_setting == 'yes' || this.decimal_setting == ''){
					if(money.indexOf(".")<0)
						money = money+'.00';
				}else{
					money = money;
				}
			return money;
		  },

		  getInwords: function(txt)
		  {


					  axios.get(this.$api_url+'/getinwords/'+txt , {
						  params: {
							  page: 1,
							  per_page: 10,
							  search_query: this.search,
							  search_query_by_id: '',
						  }
				  }).then(function(response){

				  return response.data;


			  }.bind(this));


		  },


		  getFiscalyears: function()
		  {

					  axios.get(this.$api_url+'/getfiscalyears' , {
						  params: {
							  page: 1,
							  per_page: 10,
							  search_query: this.search,
							  search_query_by_id: '',
						  }
				  }).then(function(response){
				  this.fiscalyears = response.data;


			  }.bind(this));
		  },

		  getSalaryinfo: function()
		  {
			this.payslip_loader = true;
					  axios.get(this.$api_url+'/salary-slip/'+this.employee_id , {
						  params: {
							  fiscal_year: this.fiscal_year,
							  payslip_id: this.fdata.id,
							  output_type: 'merge_report',
							  search_query_by_id: '',
						  }
				  }).then(function(response){
				  this.salaryheads = response.data.salary;
				  /* Added by Sohel starts */
				  this.salaryheads.forEach(element => {

					if(element.field_key == 'basic_salary_before_pregross' || element.field_key == 'house_rent_before_pregross' || element.field_key == 'conveyance_allowance_before_pregross' || element.field_key == 'medical_allowance_before_pregross')
					{
						this.pre_gross_flag = 1;
					}

				  });
				  /* Added by Sohel ends */
				  this.slabs_and_values=response.data.slabsnvalues;
				  this.taxinfo=response.data.tax;
				  this.adhocfields=response.data.adhocfields;
				  this.adhocheadsnvalues=response.data.adhocheadsnvalues;

				  /* at_edit  starts*/
				  let y=0;
				  let z=0;

				  let slary_flag =0;
				  let contribution =0;
				  let off_cycle_adhocs =0;
				  let deduction = 0.0;
				  let arrear = 0.0;
				  let artar = 0.0;
				  for (let x in this.salaryheads){

					  if(this.salaryheads[x].head == "Employer's Contribution to PF"){
						  contribution = this.salaryheads[x].value;
						  contribution = contribution.replaceAll(",","");
					  }



					  if(this.salaryheads[x].head == 'Gross Salary'){
						  y = this.salaryheads[x].value;
						  y = y.replaceAll(",","");

						this.gross_salary = parseFloat(y);

					  }

					if(this.salaryheads[x].displayset == 'off_cycle_adhocs'){
						off_cycle_adhocs = parseFloat(off_cycle_adhocs) + parseFloat((this.salaryheads[x].value).replaceAll(",",""));
					  }


					  if(this.salaryheads[x].head == 'Gross Pay'){
						  z = this.salaryheads[x].value;
						  z = z.replaceAll(",","");
						  z= parseFloat(z) + parseFloat(contribution);
						  this.contribution = z;
					  }

					  if(this.salaryheads[x].head == 'Total Deduction'){
						  deduction = this.salaryheads[x].value;
						  deduction = deduction.replaceAll(",","");
						  deduction = deduction.replaceAll("-","");

					  }

					if(this.salaryheads[x].displayset == 'arrear'){
						  artar = this.salaryheads[x].rawvalue;
						arrear = parseFloat(artar) + arrear;

					  }
				  }

				  this.gross_salary = this.gross_salary - arrear;
				  this.deduction = parseFloat(deduction) + parseFloat(contribution) + parseFloat(off_cycle_adhocs);
				  //this.total_other = parseFloat(z) - parseFloat(y) + arrear;
				  this.total_other = parseFloat(z) - parseFloat(y);
				  this.payslip_loader = false;
				 console.log('Gross Pay-'+z);
				 console.log('Gross Salary-'+y);

					/* at_edit  ends*/

			  }.bind(this));
		  },
		 getPayslipInfo: function()
		 {

			   axios.get(this.$api_url+'/payslipinfo/'+this.payslip, {
						params: {
						}
				}).then(function(response){
				this.fdata = response.data.data;
				this.employee_id = this.fdata.employee_id;
				if(this.fdata.id!='')
				  {
				   this.fiscal_year=this.fdata.fiscal_year;
				   this.employee_id=this.fdata.employee_id;
				   this.from_date=this.fdata.from_date;
				   this.to_date=this.fdata.to_date;
				   this.pay_slip_ref=this.fdata.pay_slip_ref;

				   //this.setSearch();
				   this.getSalaryDataFromDB('no');
				   this.pay_slip_name=this.fdata.pay_slip_name;
				   //this.changeValue();

				  }
			}.bind(this));
		 },

		getSalaryDataFromDB: function(is_taxcard)
		{
			this.payslip_loader = true;
					axios.get(this.$api_url+'/salary-slip-db/'+this.employee_id , {
						params: {
							fiscal_year: this.fiscal_year,
							payslip_id: this.fdata.id,
							output_type: 'merge_report',
							is_taxcard: is_taxcard,
							search_query_by_id: '',
						}
				}).then(function(response){

				this.salaryheads = response.data.salary;
				/* Added by Sohel starts */
				this.salaryheads.forEach(element => {

				if(element.field_key == 'basic_salary_before_pregross' || element.field_key == 'house_rent_before_pregross' || element.field_key == 'conveyance_allowance_before_pregross' || element.field_key == 'medical_allowance_before_pregross')
				{
					this.pre_gross_flag = 1;
				}

				if(element.displayset == 'tax_policy' && element.value == '1')
				{
					this.tax_policy_flag = true;
				}

				});
				/* Added by Sohel ends */
				this.slabs_and_values=response.data.slabsnvalues;
				this.taxinfo=response.data.tax;
				this.adhocfields=response.data.adhocfields;
				this.adhocheadsnvalues=response.data.adhocheadsnvalues;

				/* at_edit  starts*/
				let y=0;
				let z=0;

				let slary_flag =0;
				let contribution =0;
				let off_cycle_adhocs =0;
				let deduction = 0.0;
				let arrear = 0.0;
				let artar = 0.0;
				for (let x in this.salaryheads){

				if(this.salaryheads[x].head == "Employer's Contribution to PF"){
					contribution = this.salaryheads[x].value;
					contribution = contribution.replaceAll(",","");
				}



				if(this.salaryheads[x].head == 'Gross Salary'){
					y = this.salaryheads[x].value;
					y = y.replaceAll(",","");

					this.gross_salary = parseFloat(y);

				}

				if(this.salaryheads[x].displayset == 'off_cycle_adhocs'){
					off_cycle_adhocs = parseFloat(off_cycle_adhocs) + parseFloat((this.salaryheads[x].value).replaceAll(",",""));
				}


				if(this.salaryheads[x].head == 'Gross Pay'){
					z = this.salaryheads[x].value;
					z = z.replaceAll(",","");
					z= parseFloat(z) + parseFloat(contribution);
					this.contribution = z  + parseFloat(off_cycle_adhocs);
				}

				if(this.salaryheads[x].head == 'Total Deduction'){
					deduction = this.salaryheads[x].value;
					deduction = deduction.replaceAll(",","");
					deduction = deduction.replaceAll("-","");

				}

				if(this.salaryheads[x].displayset == 'arrear'){
					artar = this.salaryheads[x].rawvalue;
					arrear = parseFloat(artar) + arrear;

				}
				}

				this.gross_salary = this.gross_salary - arrear;
				this.deduction = parseFloat(deduction) + parseFloat(contribution) + parseFloat(off_cycle_adhocs);
				// this.total_other = parseFloat(z) - parseFloat(y) + arrear + parseFloat(off_cycle_adhocs);
				this.total_other = parseFloat(z) - parseFloat(this.gross_salary);
				if( is_taxcard != 'update'){
					this.payslip_loader = false;
				}
				// console.log('Gross Pay-'+z);
				// console.log('Gross Salary-'+this.gross_salary);



			}.bind(this));
		},
	   download_file(fileURL, fileName) {
		if (!window.ActiveXObject) {
			var save = document.createElement('a');
			save.href = fileURL;
			save.target = '_blank';
			var filename = fileURL.substring(fileURL.lastIndexOf('/')+1);
			save.download = fileName || filename;
			   if ( navigator.userAgent.toLowerCase().match(/(ipad|iphone|safari)/) && navigator.userAgent.search("Chrome") < 0) {
					document.location = save.href;
				}else{
					var evt = new MouseEvent('click', {
						'view': window,
						'bubbles': true,
						'cancelable': false
					});
					save.dispatchEvent(evt);
					(window.URL || window.webkitURL).revokeObjectURL(save.href);
				}
		}
		else if ( !! window.ActiveXObject && document.execCommand)     {
			var _window = window.open(fileURL, '_blank');
			_window.document.close();
			_window.document.execCommand('SaveAs', true, fileName || fileURL)
			_window.close();
		}
	   },

	   downloadPaySlip: function(p_slip,f_year,email_file=false,prnt_file=false)
		  {
				 this.action_loader = true;
				 var send_file = email_file ? 1: 0;
				 const config = {
					headers: { 'Content-Type': 'application/json; charset=utf-8', },
					responseType: 'blob',
				 }
				 axios.get(this.$api_url+'/payslippdf/'+f_year+'/'+p_slip , {
						  params: {
							 em_file:  send_file
						  },
						  headers: { 'Content-Type': 'application/json; charset=utf-8', },
						  responseType: 'blob',
				  }).then(function(response){

				  this.action_loader = false;
				  if(response.data){

				  if(response.data.download_name)
				  this.download_file_name = response.data.download_name;
				  else
				  this.download_file_name = this.payslip_title;


				  if(prnt_file){
					// this.download_file(response.data.file_name,this.download_file_name+'.pdf');
					if(response.data.type =='application/json'){
                        let file = new Blob([response.data], {type: 'application/json'});
                        const cast = Promise.resolve(file.text());
                        cast.then((value) => {
                            let err_obj = JSON.parse(`${value}`);
                            this.$bvToast.toast(err_obj.error_msg, {title: 'Error',variant: 'danger',solid: true});
                        });
                    }else{
                        this.global_download_file_content(response);
                    }
				  }
				  else if(email_file){
					if(response.data.success)
					this.$bvToast.toast(response.data.success, {
									   title: 'Success',
										variant: 'success',
										solid: true
									});
					else if(response.data.error)
					this.$bvToast.toast(response.data.error, {
									   title: 'Error!',
										variant: 'danger',
										solid: true
									});
				  }
				  else{
					// this.download_file(response.data.file_name,this.download_file_name+'.pdf');
					if(response.data.type =='application/json'){
                        let file = new Blob([response.data], {type: 'application/json'});
                        const cast = Promise.resolve(file.text());
                        cast.then((value) => {
                            let err_obj = JSON.parse(`${value}`);
                            this.$bvToast.toast(err_obj.error_msg, {title: 'Error',variant: 'danger',solid: true});
                        });
                    }else{
                        this.global_download_file_content(response);
                    }
					}
				  }
				  else if(response.data.error){
					this.$bvToast.toast(response.data.error, {
									   title: 'Error!',
										variant: 'danger',
										solid: true
									});
				  }else{
					this.$bvToast.toast('Unexpected server error!', {
									   title: 'Error!',
										variant: 'danger',
										solid: true
									});
				  }
				  //console.log(response.data.file_name);
			  }.bind(this));
		 },
		 formSubmit(e) {
			  e.preventDefault();
              this.getSalaryDataFromDB('no');
			  /* let currentObj = this;
			  const config = {
				  headers: { 'content-type': 'multipart/form-data' }
			   }
			   let formData = new FormData();
			   formData.append('employee_id', this.employee_id);
			   formData.append('pay_slip_ref', this.pay_slip_ref);
			   formData.append('pay_slip_name', this.pay_slip_name);
			   formData.append('month', this.month);
			   formData.append('year', this.year);
			   formData.append('from_date', this.from_date);
			   formData.append('to_date', this.to_date);
			   formData.append('fiscal_year', this.fiscal_year);
			   if(this.adhoc_field!='')
			   formData.append('adhoc_field', this.adhoc_field);
			   if(this.adhoc_field_value!='')
			   formData.append('adhoc_field_value', this.adhoc_field_value);
			   axios.post(this.$api_url+'/payslip-action-vue', formData, config)
			   .then(function (response) {
				  //currentObj.getSalaryinfo();
				  currentObj.getSalaryDataFromDB('no');
				  currentObj.success = response.data.success;
				  currentObj.fdata.id = response.data.payslip_id;
				  currentObj.adhoc_field_value="";
				  currentObj.adhoc_field="";
				  currentObj.hideAdhoc();
			  })
			  .catch(function (error) {
				  currentObj.output = error;
			  }); */
		  },

		  emailTaxCards: function(taxcard)
		  {
            // alpha fix- commented this
			//   this.action_loader = true;
			  const config = {
				  headers: { 'content-type': 'multipart/form-data' }
			  }
			  let formData = new FormData();
			  formData.append('payslipids', taxcard);
			  formData.append('modification_flag', '3');

			  axios.post(this.$api_url+'/modifypayslips', formData, config)

			  .then(function (response) {
				this.action_loader = false;

				if(response.data.success)
					this.$bvToast.toast(response.data.success, {
									   title: 'Success',
										variant: 'success',
										solid: true
									});



			  }.bind(this));
		  },
		  get_decimal_settings: function()
		  {
			  axios.get(this.$api_url+'/decimal-settings')

			  .then(function (response) {
				this.decimal_setting = response.data;
			  }.bind(this));
		  },

		// changeValue: function()
		// {
		// 	console.log(this.pmonth+'-'+this.pyear);
		// 	for (var i in this.dynamic_fields) {
		// 		if (this.dynamic_fields[i].header_left_name == 'Month') {
		// 			this.dynamic_fields[i].header_left_value = this.pmonth+'-'+this.pyear;
		// 		}
		// 		if (this.dynamic_fields[i].header_right_name == 'Month') {
		// 			this.dynamic_fields[i].header_right_value = this.pmonth+'-'+this.pyear;
		// 		}
		// 	}
		// }
	  },
	  created: function(){
		 this.getPayslipInfo();
		 this.getFiscalyears();
		 this.get_decimal_settings();



	  }
  }
</script>
